<template>
  <div class="login">
    <div id="top">
      <div class="inner" style="display: none">
        <div class="f_left">石家庄市国经人力资源管理有限公司</div>
        <ul class="f_right">
          <li class="qqtalk"></li>
          <li>
            <router-link to="register">注册</router-link>
          </li>
          <li><router-link to="login">登录</router-link></li>
          <li class="line"><a href="">常见问题</a></li>
          <li class="line"><a href="" target="_blank">承诺书</a></li>
          <li id="home_top_wzq">
            <a>网站群</a>
            <div class="sub-navgation">
              <ul>
                <li class="header_less_link">
                  <a target="_blank" href="http://124.70.105.214:9031/">总站</a>
                </li>
                <li class="header_less_link">
                  <a target="_blank" href="http://124.70.105.214:9031/">大中专毕业生就业服务网</a>
                </li>
                <li class="header_less_link">
                  <a target="_blank" href="http://124.70.105.214:9031/">石家庄国经人力资源网</a>
                </li>
                <li class="header_less_link">
                  <a target="_blank" href="http://124.70.105.214:9031/">人力资源外包</a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div id="login_header">
      <div class="inner">
        <h1></h1>
        <ul>
          <li>
            <a style="font-weight: bold; color: #0162b1" href="/">网站首页</a>
          </li>
          <li>服务热线:0311-888888/09</li>
        </ul>
      </div>
    </div>
    <div id="login_content">
      <div class="left"><img src="@/assets/images/gerenad.jpg" /></div>
      <div class="right">
        <div class="top"></div>
        <div class="mid">
          <div class="title">
            <h2 style="margin-top: 0px; padding-top: 16px">修改密码</h2>
          </div>
          <div class="line"></div>
          <div class="forms">
            <div class="form" id="login">
              <div class="form_item">
                <label for="account">手机号：</label>
                <input v-model="loginForm.telephone" id="account" class="text" type="text" />
              </div>
              <div class="form_item">
                <label for="account">身份证号码：</label><input v-model="loginForm.cardNum" id="password" class="text" type="text" />
              </div>
              <div class="form_item">
                <label for="verify">修改密码：</label><input v-model="loginForm.password" class="text" type="password" />
              </div>
              <div class="account">
                <label for="account">确认密码：</label><input v-model="loginForm.confirmPassword" class="text" type="password" />
              </div>
              <!--  -->

              <div>
                <input style="
                    height: 40px;
                    width: 60%;
                    line-height: 40px;
                    background: #225ca9;
                    color: #fff;
                    font-weight: 700;
                    border-radius: 5px;
                    margin: 10px 0 10px;
                  " type="submit" value="确认" class="anniu" @click="toResetPwd()" />
                <span>
                  <router-link to="/">返回首页</router-link>
                </span>
              </div>
            </div>
          </div>
          <div class="msg1">
            <span>还没有账号？</span>
            <router-link to="register">立即注册！</router-link>
          </div>
        </div>
        <div class="bottom"></div>
      </div>
    </div>
  </div>
</template>

<script>
import base64 from "base-64";
export default {
  data() {
    return {
      phone: "",
      code: "",
      name: "",
      password: "",
      getCodeShow: true,
      seconds: 60,
      timer: null,
      loginType: "zhanghao",
      weixin: "微信登录",
      savePwd: false,
      codeUrl: "",
      loginForm: {},
    };
  },
  created() {
    let _this = this;
    // _this.getCode();
  },
  methods: {
    getCode() {
      let _this = this;
      _this.$api.code.code().then((res) => {
        _this.captchaOnOff =
          res.captchaOnOff === undefined ? true : res.captchaOnOff;
        if (_this.captchaOnOff) {
          _this.codeUrl = "data:image/gif;base64," + res.img;
          _this.loginForm.uuid = res.uuid;
        }
      });
    },
    goPath() {
      let _this = this;
      _this.$router.push({
        path:
          _this.$route.query.redirect &&
          _this.$route.query.redirect.indexOf("login") == -1 &&
          _this.$route.query.redirect.indexOf("register") == -1
            ? _this.$route.query.redirect
            : "/",
      });
    },
    weixinAuth() {
      let _this = this;
      _this.weixin = "微信授权";
    },
    toResetPwd() {
      let _this = this;
      if (!_this.loginForm.telephone) {
        _this.$layerMsg.error("请填写手机号");
        return false;
      }
      if (!_this.loginForm.cardNum) {
        _this.$layerMsg.error("请填写身份证号码!");
        return false;
      }
      if (!_this.loginForm.password) {
        _this.$layerMsg.error("请填写密码!");
        return false;
      } else if (_this.loginForm.password.length < 6) {
        _this.$layerMsg.error("密码长度最少为6位!");
        return false;
      }
      if (!_this.loginForm.confirmPassword) {
        _this.$layerMsg.error("请填写确认密码!");
        return false;
      } else if (_this.loginForm.confirmPassword != _this.loginForm.password) {
        _this.$layerMsg.error("密码与确认密码不一致!");
        return false;
      }
      let param = {
        telephone: _this.loginForm.telephone,
        cardNum: _this.loginForm.cardNum,
        password: _this.loginForm.password,
      };
      _this.$api.user
        .forgetPassword(param)
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {
            _this.$layerMsg.success("修改成功");
            _this.$router.push({
              path: "login",
            });
          } else {
            _this.$layerMsg.error(res.msg);
            _this.$router.push({
              path: "forgetPassword",
            });
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style>
#qrcode iframe {
  width: 100% !important;
  height: 303px !important;
}
#qrcode iframe .impowerBox .normalPanel .title {
  display: none;
}
#qrcode iframe .impowerBox .qrcode {
  width: 210px;
}
.link {
  position: absolute;
  top: 145px;
  color: #4e6ef2;
}
.toReg {
  right: 0;
}
.resetPwd {
  right: 80px;
}
.login-type {
  width: 335px;
  margin: 0 auto;
}
.save-pwd {
  position: absolute;
  top: 145px;
}
.save-pwd input,
.save-pwd span {
  vertical-align: middle;
  cursor: pointer;
}
.login-type::after {
  content: "";
  width: 0;
  height: 0;
  margin: 0;
  clear: both;
  display: block;
}
.login-type .type-item {
  float: left;
  width: 50%;
  font-size: 22px;
  margin: 40px 0;
  text-align: center;
  cursor: pointer;
}
.login-type .type-item.sel {
  color: #be1a21;
}
</style>



// WEBPACK FOOTER //
// src/view/login/forgetPassword.vue